export const MAX_TIME_LEFT_TIMEOUT_MODAL = 5;

export const SESSION_STATUS = {
    OK: 'OK',
    OVERWRITTEN: 'overwritten',
    EXPIRED: 'expired',
};
